import React from "react";

const Footer = () => (
  <footer className="bg-dark text-white text-center py-3 mt-4">
    <div className="container">
      <small>&copy; {new Date().getFullYear()} JV. Todos los derechos reservados.</small>
    </div>
  </footer>
);

export default Footer;